"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyUserInfo = {
    id: null,
    masterId: null,
    userName: '',
    displayName: '',
    email: '',
    roles: [],
    personalManager: null,
    isUserFranchise: false
};
